const getEnvironment = () => {
    const isLocal = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const isAcceptance = window.location.href.includes("acceptance");

    return (isLocal || isAcceptance) ? "not-production" : "production";
};
const uploadImage = async (file) => {
    const folderPath = getEnvironment();

    const bucketUrl = `https://okapi-email-widget-assets.s3.amazonaws.com/${folderPath}/`;

    const filePath = `${bucketUrl}${file.name}`;
    try {
        const response = await fetch(filePath, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type, 
            },
            body: file, 
        });

        if (response.ok) {
            return `${filePath}`;
        } else {
            throw new Error(`Upload failed: ${response.statusText}`);
        }
    } catch (error) {
        console.error('Error uploading file:', error);
    }
};

export default uploadImage;